.root {
  --notification-color: transparent;
  margin-left: 72px;
}

.notification {
  border-radius: 8px;
  font-weight: 600;
  font-size: var(--mantine-fontSizes-md);
}
